import { HttpParams } from '@angular/common/http';
import { Component, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UTILS } from 'src/app/entities/Utils';
import { Anagrafica, Company, GenericResponse, Utente } from 'src/app/entities/various';
import { UserInfo } from 'src/app/services/login/login.service';
import { ModalServiceService } from 'src/app/services/modal-service/modal-service.service';
import { UserService } from 'src/app/services/users/user.service';
import { PersonalDataComponent } from '../inside/users/user-editor/personal-data/personal-data.component';
import { ToastService } from 'src/app/services/toast/toast.service';
import { UtenteService } from 'src/app/services/users/utente.service';
import { tipoNotifica } from '../inside/users/user-editor/user-editor.component';
import { ConfigServiceService, ItemSelectProps } from 'src/app/services/config-service/config-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})

export class ProfileComponent implements OnInit {
  @ViewChild('pdc', { static: false }) pdcomponent: PersonalDataComponent | undefined;
  
  navigator : string ='';
  
  innerWidth: number | undefined;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }

  
  me : any | undefined;
  utente: any;
  DM7info : boolean = false;
  DM7doc : boolean = false;
  recWays = [{"value" : "Codice Univoco", "key" : "C"}, {"value" : "PEC", "key" : "P"}];
  companies : Company[] = [];
  regimi : ItemSelectProps[] = [];
  params : HttpParams;
  getJson: boolean = false;
  notifiche : tipoNotifica = {"RC":false,"MC":false,"NS":false,"NE":false,"DT":false, mailNotifiche: "", push: "", token: ""};
  notificheDraft : tipoNotifica={"RC":false,"MC":false,"NS":false,"NE":false,"DT":false, "mailNotifiche": "", "push": "", "token": ""};
  mailNotifiche: string = "";

  pwFieldType : string = 'password';
  hidePw : boolean = true;

  logoSafeUrl: SafeUrl | string = 'assets/placeholder.jpeg';

  constructor( private userService: UserService, private translate : TranslateService, private confirmModalService : ModalServiceService, private toast : ToastService, 
    private utenteService: UtenteService, private configService: ConfigServiceService, private ngbModal: NgbModal, private sanitizer: DomSanitizer) {
    this.params = new HttpParams();
    this.params =this.params.append('endRow', 0);
    this.params =this.params.append('lastKeyVal', '');
    this.params =this.params.append('page', 1);
    this.params =this.params.append('pageDirection', 'FORWARD');
    this.params =this.params.append('pageSize', 12);
    this.params =this.params.append('pagination', true);
    this.params =this.params.append('paginationMode', 'SKIP');
    this.params =this.params.append('rows', 0);
    this.params =this.params.append('searchFilter', '{}');
    this.params =this.params.append('sortDir', 'ASC');
    this.params =this.params.append('sortKey', '');
    this.params =this.params.append('startRow', 0);
    this.params =this.params.append('totalPages', -1);
    this.params =this.params.append('totalRows', 0);
    this.innerWidth = window.innerWidth;
    
   }

  async ngOnInit(): Promise<void> {
    this.navigator = 'sidebar.profile ';
    this.me = JSON.parse(localStorage.getItem("einvuser") || "");

    this.utenteService.getUtente(this.me.user_id).then(
      (res) => {
        this.utente = res.data;
        //this.utente!.iban_list = Object.values(JSON.parse(res.data.iban_list));

        if (this.utente.img_logo_path) {
          this.logoSafeUrl = this.sanitizer.bypassSecurityTrustUrl(
            'data:image/png;base64,' + this.utente.img_logo_path
          );
        }

        this.utenteService.dettagliFatturazione(this.me.user_id).then(
          (res) => {
            this.notifiche = JSON.parse(res.data.invio_notifiche);
          }
        );
      }
    )

    
    let list = (await this.configService.getJSON()).list;
    this.regimi = list.listRegimeFiscale;
  }

  setJsonData(json_data : Anagrafica) {
    this.me!.sdi_data = json_data;
    this.me!.json_sdi_data = JSON.stringify(json_data);

  }

  async save() {
    // In questo modo il padre richiama il metodo presente nel componente figlio che a sua volta richiamaerà un metodo nel padre
    // this.pdcomponent?.emitData();
    
    // CONSIGLIATO
    // All'interno del padre ho creato il metodo pubblico getJsonAnagrafica che posso richiamare puntanto all'instanza del componente
    // N.B. Se si ha l'istanza del componente è possibile anche non utilizzare @Output ma puntare ai metodo pubblici presente nel componente figlio

    if (this.utente != undefined) {
      let label : string = await new UTILS().getTranslateTitle(this.translate,"modal.labels.save");
      let message : string = await new UTILS().getTranslateTitle(this.translate,"modal.messages.save");
      let check = await this.confirmModalService.openConfirm(label, message);
      if (check && this.convalidaDati()) {
        let response : GenericResponse =  await this.utenteService.aggiornaProfilo(this.utente);
        if(response.success) {
          this.toast.openToast(await new UTILS().getTranslateTitle(this.translate,"toast.save.success"), "success");
          this.me = await (await this.userService.getManagedUserById(this.me!.dms_user_id, response.data.id)).data;
        }else {
          this.toast.openToast(response.msg, "warning");
        }
      }
    }
    
  }


  convalidaDati(){

    if (this.utente?.denominazione.length == 0) {
      this.toast.openToast("Denominazione mancante", "warning");
      return false;
    }

    if (this.utente?.partita_iva.length == 0 && this.utente?.codice_fiscale.length == 0) {
      this.toast.openToast("Partita IVA o Codice fiscale mancante", "warning");
      return false;
    }

    if (this.utente?.indirizzo.length == 0) {
      this.toast.openToast("Indirizzo mancante", "warning");
      return false;
    }

    if (this.utente?.cap.length == 0) {
      this.toast.openToast("CAP mancante", "warning");
      return false;
    }

    if (this.utente?.comune.length == 0) {
      this.toast.openToast("Comune mancante", "warning");
      return false;
    }

    if (this.utente?.provincia.length == 0) {
      this.toast.openToast("Provincia mancante", "warning");
      return false;
    }

    if (this.utente?.nazione.length == 0) {
      this.toast.openToast("Nazione mancante", "warning");
      return false;
    }

    return true;

    /*if(this.me!.role !='A' && this.me!.role!='S'){
        if(this.me!.email=='' || this.me!.email==undefined){
          this.toast.openToast("Inserisci l'indirizzo email", "warning");
            return false;
        }
        if(this.me!.mod_ric_fp==''){
          this.toast.openToast( "Seleziona la modalità di ricezione delle fatture passive", "warning");
          return false;
        }
        if(this.me!.mod_ric_fp=='P' && (this.me!.email_pec=="")){
          this.toast.openToast( "Compila il campo email pec nella modalità di ricezione delle fatture passive", "warning");
          return false;
        }
        if(this.me!.mod_ric_fp=='C' && (this.me!.codice_univoco=="" || this.me!.codice_univoco.length!= 7)){
          this.toast.openToast( "Il codice univoco contiene un valore non corretto", "warning");
          return false;
        }
        if(this.me!.sdi_data?.DatiAnagrafici.Anagrafica.PersonaFisica==1){
            if(this.me!.sdi_data?.DatiAnagrafici.Anagrafica.Cognome=="" || this.me!.sdi_data?.DatiAnagrafici.Anagrafica.Nome==""){
              this.toast.openToast("Inserisci nome e cognome dell'utente","warning");   
              return false;
            }
            //cf 
            if(this.me!.sdi_data?.DatiAnagrafici.CodiceFiscale==""){
              this.toast.openToast("Inserisci il codice fiscale dell'utente","warning");   
              return false;
            }
         }else{
          if(this.me!.sdi_data?.DatiAnagrafici.Anagrafica.Denominazione==""){
            this.toast.openToast("Inserisci la denominazione","warning");   
            return false;
          }
          if(this.me!.sdi_data?.DatiAnagrafici.IdFiscaleIVA.IdCodice=="" || this.me!.sdi_data?.DatiAnagrafici.IdFiscaleIVA.IdPaese==""){
            this.toast.openToast("Inserisci nazione e partita iva","warning");   
            return false;
          }
        }
        if(this.me!.sdi_data?.Sede.CAP=="" || this.me!.sdi_data?.Sede.Comune=="" 
        || this.me!.sdi_data?.Sede.Indirizzo=="" || this.me!.sdi_data?.Sede.Nazione=="" 
        || this.me!.sdi_data?.Sede.Provincia==""){
          this.toast.openToast("Compila tutti i campi della Sede","warning");  
          return false;
        }
        return true;
    }else{
      return true;
    }*/
  }

  async changePassword() {
    await this.confirmModalService.openChangePassword(this.me!.user_id);
  }

  public setNotifica(type : string){
      if(type=='RC')
        this.notifiche.RC=!this.notifiche.RC;
      if(type=='MC')
        this.notifiche.MC=!this.notifiche.MC;
      if(type=='NS')
        this.notifiche.NS=!this.notifiche.NS;
      if(type=='NE')
        this.notifiche.NE=!this.notifiche.NE;
      if(type=='DT')
        this.notifiche.DT=!this.notifiche.DT;

      this.utenteService.invioNotifiche(this.utente.user_id, this.notifiche).then(
        (res) => {
          if (res.success)
          {
            this.toast.openToast(res.msg, "success");
          } else {
            this.toast.openToast(res.msg, "warning");
          }
        }
      );
  }

  changeVisibility() {
    this.hidePw= !this.hidePw;
    if(this.hidePw) {
      this.pwFieldType='password'
    } else {
      this.pwFieldType='text'
    }
  }

  openNotificheModal(content: TemplateRef<any>) {
    this.notificheDraft = { ...this.notifiche };
    this.ngbModal.open(content, { size: 'lg' });
  }
  
  saveNotificheModal(modal: any) {
    this.notifiche.push = this.notificheDraft.push;
    this.notifiche.token = this.notificheDraft.token;

    this.utenteService.invioNotifiche(this.utente.user_id, this.notifiche).then(
      (res) => {
        if (res.success) {
          this.toast.openToast(res.msg, "success");
          modal.close();
        } else {
          this.toast.openToast(res.msg, "warning");
        }
      }
    );
  }

  openLogoModal(content: TemplateRef<any>) {
    this.ngbModal.open(content, { size: 'lg' });
  }

  salvaLogoAzienda(event: any, modal: any) {
    let file = (event.target.files as FileList)[0];

    if (!file) return;

    const tipiAmmessi = ['image/jpeg', 'image/png', 'image/webp'];
    if (!tipiAmmessi.includes(file.type)) {
      this.toast.openToast("Errore: il file selezionato non è un'immagine valida (ammessi JPG, PNG, WEBP).", "error");
      event.target.value = ''; // Reset dell'input
      return;
    }


    const reader = new FileReader();
    reader.onload = (e: any) => {
      const img = new Image();
      img.src = e.target.result;

      img.onload = () => {
        const larghezza = img.width;
        const altezza = img.height;

        if (larghezza <= 0 || altezza <= 0) {
          this.toast.openToast("Errore: impossibile leggere le dimensioni dell'immagine.", "warning");
          event.target.value = '';
          return;
        }

        const dimensioneLogo = 600;
        const scala = Math.min(1, dimensioneLogo / larghezza, dimensioneLogo / altezza);
        const larghezzaDestinazione = Math.round(larghezza * scala);
        const altezzaDestinazione = Math.round(altezza * scala);
        const destinazioneX = Math.floor((dimensioneLogo - larghezzaDestinazione) / 2);
        const destinazioneY = Math.floor((dimensioneLogo - altezzaDestinazione) / 2);
        const canvas = document.createElement('canvas');
        canvas.width = dimensioneLogo;
        canvas.height = dimensioneLogo;

        const context = canvas.getContext('2d');
        if (!context) {
          this.toast.openToast("Errore durante il ridimensionamento dell'immagine.", "error");
          event.target.value = '';
          return;
        }

        if (file.type === 'image/jpeg') {
          context.fillStyle = '#ffffff';
          context.fillRect(0, 0, dimensioneLogo, dimensioneLogo);
        }

        context.drawImage(img, destinazioneX, destinazioneY, larghezzaDestinazione, altezzaDestinazione);
        const logoDataUrl = canvas.toDataURL(file.type);
        const logoBlob = this.dataUrlToBlob(logoDataUrl);
        const limitePeso = 700 * 1024;

        if (logoBlob.size > limitePeso) {
          const pesoInMb = (logoBlob.size / (1024 * 1024)).toFixed(2);
          this.toast.openToast(`Errore: il file ridimensionato e troppo grande (${pesoInMb} MB). Il limite massimo e 700 KB.`, "error");
          event.target.value = '';
          return;
        }

        let formData = new FormData();
        formData.append("file", logoBlob, file.name);

        this.utente.img_logo_path = logoDataUrl;

        this.utenteService.caricaLogo(this.utente.user_id, formData).then(
          (res) => {
            this.utente.img_logo_path = res.msg;
            this.toast.openToast("Logo caricato correttamente", "success");
            modal.close();
          }
        );
      };
    };
    reader.readAsDataURL(file);
  }

  private dataUrlToBlob(dataUrl: string): Blob {
    const parts = dataUrl.split(',');
    const mime = parts[0].match(/:(.*?);/)?.[1] || 'image/png';
    const binary = atob(parts[1]);
    const bytes = new Uint8Array(binary.length);

    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }

    return new Blob([bytes], { type: mime });
  }

}
